"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.newSwappaRouterV1 = exports.ABI = void 0;
exports.ABI = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            { indexed: false, internalType: "address", name: "to", type: "address" },
            {
                indexed: true,
                internalType: "address",
                name: "input",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "output",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "inputAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "outputAmount",
                type: "uint256",
            },
        ],
        name: "Swap",
        type: "event",
    },
    {
        inputs: [
            { internalType: "address[]", name: "path", type: "address[]" },
            { internalType: "address[]", name: "pairs", type: "address[]" },
            { internalType: "bytes[]", name: "extras", type: "bytes[]" },
            { internalType: "uint256", name: "inputAmount", type: "uint256" },
        ],
        name: "getOutputAmount",
        outputs: [
            { internalType: "uint256", name: "outputAmount", type: "uint256" },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address[]", name: "path", type: "address[]" },
            { internalType: "address[]", name: "pairs", type: "address[]" },
            { internalType: "bytes[]", name: "extras", type: "bytes[]" },
            { internalType: "uint256", name: "inputAmount", type: "uint256" },
            { internalType: "uint256", name: "minOutputAmount", type: "uint256" },
            { internalType: "address", name: "to", type: "address" },
            { internalType: "uint256", name: "deadline", type: "uint256" },
        ],
        name: "swapExactInputForOutput",
        outputs: [
            { internalType: "uint256", name: "outputAmount", type: "uint256" },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address[]", name: "path", type: "address[]" },
            { internalType: "address[]", name: "pairs", type: "address[]" },
            { internalType: "bytes[]", name: "extras", type: "bytes[]" },
            { internalType: "uint256", name: "inputAmount", type: "uint256" },
            { internalType: "uint256", name: "minOutputAmount", type: "uint256" },
            { internalType: "address", name: "to", type: "address" },
            { internalType: "uint256", name: "deadline", type: "uint256" },
        ],
        name: "swapExactInputForOutputWithPrecheck",
        outputs: [
            { internalType: "uint256", name: "outputAmount", type: "uint256" },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
function newSwappaRouterV1(web3, address) {
    return new web3.eth.Contract(exports.ABI, address);
}
exports.newSwappaRouterV1 = newSwappaRouterV1;
//# sourceMappingURL=SwappaRouterV1.js.map